import { createSignalRContext } from 'react-signalr';

export enum CrisisSignalREvent {
  ALLOCATIONS_CREATED = 'AllocationsCreated',
  ALLOCATIONS_DELETED = 'AllocationsDeleted',
  ALLOCATIONS_UPDATED = 'AllocationsUpdated',
  CRISIS_CALL_DELETED = 'CrisisCallDeleted',
  CRISIS_CALL_RECEIVED = 'CrisisCallReceived',
  CRISIS_CALL_RESOLVED = 'CrisisCallResolved',
  CRISIS_CALL_UPDATED = 'CrisisCallUpdated',
  VISIT_CANCELED = 'VisitCanceled',
  VISIT_FINISHED = 'VisitFinished',
  VISIT_STARTED = 'VisitStarted',
}

interface IProps<T> {
  action: CrisisSignalREvent;
  callback?: (data: T) => void;
  shouldRefetchCrisisCalls?: boolean;
}

export const SignalRCrisisContext = createSignalRContext({
  shareConnectionBetweenTab: true,
});

const useCrisisSignalR = <T,>({ action, callback }: IProps<T>): void => {
  SignalRCrisisContext.useSignalREffect<string, any>(
    action,
    (data: T) => {
      callback?.(data);
    },
    [],
  );
};

export default useCrisisSignalR;
